import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { Permission } from '../../models/principal/permission';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  constructor(private authService: AuthService) {
  }

  resolveUserPermissions(requiredPermissions: Permission[]): { [key: string]: boolean } {
    return requiredPermissions.reduce((acc, permission) => {
      acc[permission] = this.authService.hasPermission(permission);
      return acc;
    }, {});
  }

  resolveAPIPermissions(requiredPermissions: any[]): { [key: string]: boolean } {
    return requiredPermissions.reduce((acc, permission) => {
      acc[permission.key] = this.authService.hasAPIPermission(permission);
      return acc;
    }, {});
  }

}
